import React from 'react';
import TypeSearchForm from '../type-search/type-search';
import NumberSearchForm from '../number-search/number-search';

const Features = () => {
  return (
    <div className="footer-widget-heading padding-both">
        <h3>New Features</h3>
        <div className="year" style={{paddingBottom: "1.5em"}}>
          <h2>July 2026</h2>
          <div className="bukvitsa">
          We have improved access to listings of the most renowned museum collections of the Rus' bullae - <a href="./collection/2">Dumbarton Oaks</a>, <a href="./collection/1">Sheremetievs’ Family Museum</a>, <a href="./collection/4">Novgorod Museum-Reserve</a>, <a href="./collection/3">National Museum of Poland</a>.
          </div>   
        </div>
        <div className="year" style={{paddingBottom: "1.5em"}}>
          <h2>July 2026</h2>
          <div className="bukvitsa">
          To improve discoverability, we unified descriptive model for each category of seal issuers.
          In particular, we created a distingiushed page called <a href='./emitters/'>Onomasticon</a> to list all known (and supposed) emitters. This was needed, as previously non-dynastic figures (e.g. spouses, ecclesiastical figures, governors) were difficult to locate, as they are not part of the <a href='./genealogy/'>princely genealogical structure</a>. 
          Also, we added support for individuals with unknown dates of death, and/or unknown from written sources but attested by seals (<a href='./person/408'>example</a>).
          </div>   
        </div>
        <div className="year" style={{paddingBottom: "1.5em"}}>
          <h2>June 2026</h2>
          <div className="bukvitsa">
          We added a dedicated field with support for Greek and Old Slavonic scripts, distinct from obverse and reverse type descriptions. This is called to avoid duplication between Russian and English textual descriptions, and increase their accuracy.
          Now we display multi-line legends in vertical (columnar) format, reflecting established Byzantine and Rus’ sigillographic conventions (<a href='./type/10443/10444'>see an example</a>).
          </div>   
        </div>
        <div className="year" style={{paddingBottom: "1.5em"}}>
          <h2>May 2026</h2>
          <div className="bukvitsa">
          We adopted the UI to handle electronic resources appropriately in the <a href='./publications/'>list of cited publications</a> and specimen publication references.
          Now, their citations use stable web URLs with the effective date of access, instead of page numbers.
          </div>   
        </div>
        <div className="year" style={{paddingBottom: "1.5em"}}>
          <h2>April 2026</h2>
          <div className="bukvitsa">
          We integrated standard academic fields used in scholarly object descriptions, such as current repository and inventory number, and created a dedicated database structure to group items by collection.
          </div>   
        </div>
        <div className="year" style={{paddingBottom: "1.5em"}}>
          <h2>January 2026</h2>
          <div className="bukvitsa">
          Image carousel of saints and some princes was integrated into the design of the main page as <a href='./'>Images of Power</a> section.
          You can enlarge any image and pause the carousel by hovering over it, or click on the image to view the details.
          </div>   
        </div>
        <div className="year" style={{paddingBottom: "1.5em"}}>
          <h2>December 2025</h2>
          <div className="bukvitsa">
          <a href='https://server.kievan-rus.online/index-html/'>Printable database index</a> is now available to facilitate citation of any sigillographic publication.
          </div>   
        </div>
        <div className="year" style={{paddingBottom: "1.5em"}}>
          <h2>November 2025</h2>
          <div className="bukvitsa">
          We added support of the Windows platform for <a href='./offline/'>offline assemblies</a>, and the <i>Athena Ruby</i> font for <a href='./type/10963/10964'>Greek text</a>.
          </div>   
        </div>
        <div className="year" style={{paddingBottom: "1.5em"}}>
          <h2>October 2025</h2>
          <div className="bukvitsa">
          We deployed Kievan-Rus.Offline - an offline distribution of our complete database. It ensures long-term preservation and autonomous access to the full dataset when the online service may no longer be available.<br /><br />
          Please complete <a href='./offline/'>the request form</a> and tell us who you are and why you require a copy. After receiving your submission, we will send a personalized download link.
          </div>   
        </div>
        <div className="year" style={{paddingBottom: "1.5em"}}>
          <h2>September 2025</h2>
          <div className="bukvitsa">
          According to the citation framework that was implemented in June, we now allow to search the system by a specimen and a type number from the <a href='./'>home page</a>.  <br /><br />
          The system also allows to generate the <a href='https://server.kievan-rus.online/yanin-html/'>Table of Correspondence between Yanin–Gaydukov Numbers and SAR Types</a> in a printable format from the current state of the database.
          </div>   
        </div>
        <div className="year" style={{paddingBottom: "1.5em"}}>
          <h2>August 2025</h2>
          <div className="bukvitsa">
          <a href='./publication/96'>The largest selection of seals found in Drohiczyn, published by K. Bolsunowski</a>, containing almost 1000 specimens, has been added to the database.
          </div>   
        </div>
        <div className="year" style={{paddingBottom: "1.5em"}}>
          <h2>July 2025</h2>
          <div className="bukvitsa">
            Much of the data was entered into the database on a public and volunteer basis, and therefore suffers from a lack of consistency. This month, we started the creation of scholarly descriptions for auxiliary data to enhance researchers’ contextual understanding. This initiative will enable sigillographers to interpret the imagery on seals better, minimizing the risk of errors in their description and attribution.<br /><br />
            We started by preparing 100 illustrated reference articles on the history of veneration and details of the iconography of Christian saints in Rus': now you can see <a href='./iconography'>the enhanced iconography</a> page and enhanced pages of particular saints, e.g. <a href='./saint/2'>Theodor of Amasea</a>. The reference articles are linked from every stamp pair page.
            <div><img src="https://server.kievan-rus.online/video/saints_reference.png" width="386px" /></div>
          </div>
        </div>
        <div className="year" style={{paddingBottom: "1.5em"}}>
          <h2>June 2025</h2>
          <div className="bukvitsa">

          We standardized the numbering of dies (both obverse and reverse of each seal) into a uniform five-digit format. We enable users to conveniently copy a link to the number of the die pair on <a href='https://kievan-rus.online/type/10003/10004' target='_blank'>every type page</a>, along with a reference to the Yanin-Gaidukov corpus of seals of Ancient Rus’ where present.
          <div style={{ float: "right", margin: "0 0 1rem 1rem" }}>
            <TypeSearchForm />
          </div>
          <br /><br />
          In the Yanin-Gaidukov system, each pair of dies is assigned a sequential number in the corpus, such as <i>30</i>, while newly discovered die pairs receive lettered indices (e.g., <i>30a</i>, <i>30bb</i>, etc.). As a result, the numbering system becomes increasingly cumbersome due to the ongoing accumulation of material and the frequent emergence of previously unknown dies. Moreover, their system does not account for cases where multiple specimens share common dies — for example, when a single obverse is used with two or three different reverses. Additionally, the Yanin-Gaidukov numbering does not include small seals used for securing fur money.
          <br /><br />
          For these reasons, we introduced a unique reference number to each individual die. We define seal types based on the combination of obverse and reverse numbers, for instance, <i>SAR</i> (Seals of Ancient Rus’), <a href='https://kievan-rus.online/type/10003/10004' target='_blank'>T 10003/10004</a>.
          <div style={{ float: "right", margin: "0 0 1rem 1rem" }}>
            <NumberSearchForm />
          </div>
          <br /><br />
          At the same time, the ability to search simply by the specimen number in the database has been left, e.g. <a href='https://kievan-rus.online/type/10001/10002/11001' target='_blank'>11001</a>.
          </div>   
        </div>
        <div className="year" style={{paddingBottom: "1.5em"}}>
          <h2>November 2024</h2>
          <div className="bukvitsa">
          The main page now contains the <a href='./'>graph</a> showing the number of attributed seals over time.
          You can click on the timeline to select the princes active near the date.
          </div>   
        </div>
        <div className="year" style={{paddingBottom: "1.5em"}}>
          <h2>September 2024</h2>
          <div className="bukvitsa">
          The new <a href='./iconography'>Iconography</a> section is now available. It allows us to track saints' popularity changing over time, and quickly access all seals depicting a saint in the database.
          Please be aware that the dating of the seals is based on their existing attributions, so unattributed seals are missing from the stats.
          </div>   
        </div>
        <div className="year" style={{paddingBottom: "1.5em"}}>
          <h2>August 2024</h2>
          <div className="bukvitsa">
            Princely signs (tamghas) have been redrawn in <a href='https://server.kievan-rus.online/signs/24.svg' target='_blank'>vector format</a> to look more uniform and load faster.
          </div>   
        </div>
        <div className="year" style={{paddingBottom: "1.5em"}}>
          <h2>July 2024</h2>
          <div className="bukvitsa">
          Russian, Belarusian, and Ukrainian descriptions of the princes (<a href='./person/42'>example</a>), seal obverses and reverses (<a href='./type/100016188/100016189'>example</a>), and <a href='./publications'>publication names</a> are translated into English. 
          </div>   
        </div>
        <div className="year" style={{paddingBottom: "1.5em"}}>
          <h2>June 2024</h2>
          <div className="bukvitsa">
          The new <a href='./genealogy'>Genealogy</a> section is now available. In this section, you can view the Rurikid dynasty tree from any prince, extending four generations down if the prince's heirs are known. 
          To expand the tree down from any prince, click the down arrow under their node. To go up a level and view the tree from the prince’s father, click the up arrow under the topmost node.
          </div>
          <br />

          <div>The left menu allows for quick navigation to the root tree of the Rurikids and to the three main branches: the Ragnvald's grandchildren, the Monomashichi, and the Olgovichi.
          </div>
          <br />

          <div>On a prince's card, you can quickly access a page with a description of the prince's seals. The number of seal types attributed to the prince is indicated in brackets. Below this, you will find the prince's baptismal name and year of death. The princely signs found on the prince's seals are shown next; clicking on each sign will display all the seals with that sign (even those not attributed to the prince). 
          </div>
          <br />
          <div>The next line indicates the saints found on the prince's seals, excluding the prince's own holy patron. If the saint's image is associated with the prince's father, it is marked with an "F" tag; otherwise, it is marked with "!". This information provides insight into the validity of existing attributions and offers additional analysis opportunities for researchers.
          </div>    
        </div>
        <div className="year" style={{paddingBottom: "1.5em"}}>
          <h2>May 2024</h2>
          <div className="bukvitsa">
          With the increase in the seal number in the database, the task of facilitating discoverability and minimizing editorial mistakes arose. In May 2024, we introduced the ability to search by <a href='./search/saints/2b,c/crosses/2'>unidentified saints</a> as well as groups of saints and <a href='./search/signs/32e/crosses/null'>princely signs</a>. The new functionality should speed up the search and recognition of mediocre preserved specimens and help identify previously unidentified images.
          <div><img src="https://server.kievan-rus.online/video/search_options.png" width="600px" /></div>
          Moreover, it became possible to find <a href='./search/crosses/4/other/nulla'>all possible image combinations</a> for any particular image that will be useful if only one side of a seal is clearly visible.
          </div>
        </div>
        <div className="year" style={{paddingBottom: "1.5em"}}>
          <h2>April 2024</h2>
          <div className="bukvitsa">
          The <a href='./paleography'>Palaeography</a> section was created to enhance the possibility of studying ancient Rus' seals from this point of view. All letter combinations met on small seals are listed there.
          </div>
        </div>
      </div>
  );
};

export default Features;